import produce from "immer";
import auth from "../AuthService";
import { EVO } from "../EVO";

const USER_RETRIEVED = 'peptalkr/user/RETRIEVED';
const USER_LOGGEDOUT = 'peptalkr/user/LOGGEDOUT';
const NO_PICTURE = 'peptalkr/user/NO_PICTURE';

export const retrieved = user => ({ type: USER_RETRIEVED, user });
export const loggedout = () => ({ type: USER_LOGGEDOUT });
export const noPicture = () => ({ type: NO_PICTURE });

export const getlogindata = () => (dispatch) => {
    const user = auth.getInstance().getUser();
    if (user && user.roles && user.roles.length > 0) {
        dispatch(retrieved(user));
    }
    else if (user) {
        auth.getInstance().logout();
    }
};

export const assignNoPicture = () => (dispatch) => {
    dispatch(noPicture());
}

export const startSession = (history) => (dispatch) => {
    auth.getInstance().handleAuthentication(history, () => {
        const user = auth.getInstance().getUser();
        if (user) {
            dispatch(retrieved(user));
            var returnPath = EVO.storage.get('_evo_loginReturnPath');
            if (returnPath && history) {
                history.push(returnPath);
            }
            EVO.storage.remove('_evo_loginReturnPath');
        }
    });
};

export const endSession = () => (dispatch) => {
    auth.getInstance().logout(true);
};

const initialState = {
    name: null,
    picture: null,
    roles: [],
    noPicture: false,
    asClientId: null,
    asClientName: null
};

export default produce((draft, action) => {
    switch (action.type) {
        case USER_RETRIEVED:
            draft.name = action.user.name;
            draft.picture = action.user.picture;
            draft.roles = action.user.roles;
            draft.asClientId = action.user.asClientId;
            draft.asClientName = action.user.asClientName;
            return;
        case USER_LOGGEDOUT:
            draft.name = null;
            draft.picture = null;
            draft.roles = null;
            return;
        case NO_PICTURE:
            draft.noPicture = true;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/user.js